export var COMPONENT_NAME = 'TranquilTouch';